// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"styles__bodyWrapper___zqb2_","buttons":"styles__buttons___2x7lC"};